import '../../style/index.less';
import './index.less'; // style dependencies

import '../../select/style';
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/pagination/style/index.js
// module id = 366
// module chunks = 0